export default {
    en: {
        PAGE_SKIP_TO_MAIN_CONTENT: 'Skip to main content',
    }
};
